import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import {useSelector} from 'react-redux';
import {makeStyles} from '@mui/styles';
import {ChangeEvent, useCallback, useMemo} from 'react';
import {v4 as uuidv4} from 'uuid';
import {
  baseMsgScriptProps,
  neptuneStringMsgScriptProps,
  stringMsgScriptProps,
} from './OnboardingMessageRequest';
import {ICmpyContacts} from '../../../../../react_query/users/CompanyContacts';
import {IMediaTrack} from '../../../../../dto/MediaTrack.dto';
import {isInternalSelector} from '../../../../../store/Slices/userSlice';
import ExistingCampaignChooserBtn from '../../../../sponsor/ExistingCampaignChooserBtn';
import {CompanyDetailsList} from '../../../../../components/onboarding/CompanyDetailsList';
import {MessageAlert} from '../../../../messages/event-specific/EsmMessages';
import {CustomTextarea} from '../../../../../components/styles/CustomTextarea';
import MusicPreviewBtn from '../../../../../components/music/MusicPreviewBtn';
import MessageAddButton from '../../../../../components/styles/buttons/MessageAddButton';
import {invalidBaseMessageName} from '../../../../contacts/messages/base/BaseMessageFunctionalities';
import {manipulateText} from '../../../../../components/utlis/date-time/SecondsNumberToTimeFormat';
import IconEditButton from '../../../../../components/Button/IconEditButton';
import IconDeleteButton from '../../../../../components/Button/IconDeletebutton';

const stringStyles = makeStyles({
  stingerInputBox: {
    border: '1px solid var(--blue-variant12)',
  },
});

export const DJMessageSelectionList = ({
  selectedDjTracks,
  setSelectedDjTracks,
  baseScripts,
  setBaseScripts,
  companyId,
  isNR,
}: {
  baseScripts: baseMsgScriptProps[];
  setBaseScripts: React.Dispatch<React.SetStateAction<baseMsgScriptProps[]>>;
  selectedDjTracks: IMediaTrack[];
  setSelectedDjTracks: React.Dispatch<React.SetStateAction<IMediaTrack[]>>;
  companyId: number;
  isNR: boolean;
}) => {
  const handleBaseMessageChange = (
    id: number | string | null,
    field: keyof baseMsgScriptProps,
    value: string,
  ) => {
    if (setBaseScripts) {
      setBaseScripts(prevScript => {
        return prevScript.map(script => {
          if (script.id === id) {
            if (field === 'name') {
              const newName = value;
              return {...script, name: newName};
            }
            if (field === 'message') {
              const newMessage = value;
              return {...script, message: newMessage};
            }
          }
          return script;
        });
      });
    }
  };
  const isStaff = useSelector(isInternalSelector);

  return (
    <Box>
      <CompanyDetailsList
        company_id={companyId}
        taskSlug='create_dj_stinger_message'
        className='max-h-184 overflow-auto scrollbar'
      />
      <Box className='flex justify-between'>
        <Box>
          <Typography
            variant='h5'
            className='text-white font-bold mt-2 mb-6 m-0'>
            Base Message
          </Typography>
        </Box>
        <Box>
          {isStaff && isNR ? (
            <ExistingCampaignChooserBtn
              tracks={selectedDjTracks}
              onChange={setSelectedDjTracks}
              label='Choose Base Message'
              type='base-message'
              max={20}
              companyId={companyId}
            />
          ) : null}
        </Box>
      </Box>
      {isNR ? (
        <BaseMessageInput
          messages={baseScripts}
          setMessages={setBaseScripts}
          setSelectedDjTracks={setSelectedDjTracks}
        />
      ) : (
        <Box className='flex justify-start items-center flex-row flex-wrap onboarding'>
          {baseScripts &&
            baseScripts.map(base => (
              <Box m={0} className='mb-5 flex items-start gap-1' key={base.id}>
                <TextField
                  id='message-name'
                  className='w-200 text-white radius-5 p-0 min-h-40 h-40'
                  variant='outlined'
                  value={base.name}
                  InputProps={{
                    style: {
                      background: '#000000E6',
                    },
                    placeholder: 'Message Name *',
                  }}
                  onChange={event =>
                    handleBaseMessageChange(base.id, 'name', event.target.value)
                  }
                />
                <TextField
                  id='message-description'
                  className='radius-5 pl-0 w-600 pr-0 pb-0 min-h-100 h-150 items-start '
                  multiline
                  value={base.message}
                  InputProps={{
                    style: {
                      background: '#000000E6',
                    },
                  }}
                  placeholder='Enter Message here'
                  onChange={event =>
                    handleBaseMessageChange(
                      base.id,
                      'message',
                      event.target.value,
                    )
                  }
                />
              </Box>
            ))}
        </Box>
      )}
    </Box>
  );
};

export const StingerMessageSelectionList = ({
  stingersScripts,
  setStingersScripts,
  nrStingerScripts,
  setNrStingerScripts,
  isGT,
  companyId,
}: {
  stingersScripts: stringMsgScriptProps[] | undefined;
  setStingersScripts: React.Dispatch<
    React.SetStateAction<stringMsgScriptProps[]>
  >;
  nrStingerScripts: neptuneStringMsgScriptProps[];
  setNrStingerScripts?: React.Dispatch<
    React.SetStateAction<neptuneStringMsgScriptProps[]>
  >;
  isGT?: boolean;
  companyId: number;
}) => {
  const Strinclass = stringStyles();

  const selectedCount = nrStingerScripts.filter(
    script => script.isSelected,
  ).length;

  const handleStingerChange = (
    id: number | string | null,
    value: string,
    field: string,
  ) => {
    if (isGT) {
      setStingersScripts(prevScripts => {
        return prevScripts.map(script => {
          if (script.id === id) {
            if (field === 'radio') {
              if (script.isSelected !== undefined) {
                return {...script, isSelected: parseInt(value)};
              }
            }
            if (field === 'name') {
              return {...script, name: value};
            }
            if (field === 'message') {
              if (script.isSelected !== undefined) {
                const index = parseInt(script.isSelected.toString());
                const newMessage = script.message.map((msg, idx) =>
                  idx === index ? value : msg,
                );
                return {...script, message: newMessage};
              }
            }
          }
          return script;
        });
      });
    } else {
      if (setNrStingerScripts) {
        setNrStingerScripts(prevScripts => {
          return prevScripts.map(script => {
            if (script.id === id) {
              if (field === 'radio') {
                return {...script, isSelected: !script.isSelected};
              }
              if (field === 'name') {
                return {...script, name: value};
              }
              if (field === 'message') {
                return {...script, message: value};
              }
            }
            return script;
          });
        });
      }
    }
  };
  return (
    <Box>
      <CompanyDetailsList
        company_id={companyId}
        taskSlug='create_dj_stinger_message'
        className='max-h-184 overflow-auto scrollbar'
      />
      <Box className='flex justify-between'>
        <Box>
          <Typography
            variant='h5'
            className='text-white font-bold mt-2 mb-6 m-0'>
            Stringer Messages
          </Typography>
        </Box>
      </Box>
      {!isGT && (
        <Box className='text-center my-2'>
          {' '}
          Selected Stingers - {selectedCount}
        </Box>
      )}
      <Box
        className={`flex justify-start items-center flex-row flex-wrap p-3 h-299 scrollbar overflow-auto onboarding ${Strinclass.stingerInputBox}`}>
        {isGT
          ? stingersScripts?.map(stri => (
              <Box
                m={0}
                className='flex w-full items-start gap-1 pb-5 pl-2'
                sx={{border: '2px dashed var(--blue-variant5)'}}
                key={stri.id}>
                <TextField
                  id='message-name'
                  className='w-200 text-white radius-5 p-0 min-h-40 h-40 mt-4'
                  variant='outlined'
                  value={stri.name}
                  InputProps={{
                    style: {
                      background: '#000000E6',
                    },
                    placeholder: 'Message Name *',
                  }}
                  onChange={event =>
                    handleStingerChange(stri.id, event.target.value, 'name')
                  }
                />
                <Box className='w-full flex flex-column gap-4'>
                  {stri.message.map((msg, index) => {
                    return (
                      <Box
                        key={index}
                        className='flex flex-wrap w-full justify-between items-center p-2'>
                        <Box className='w-full flex '>
                          {stri.message.length > 1 && (
                            <RadioGroup
                              row
                              aria-labelledby='days_selection_label'
                              name={`radio-buttons-group-${stri.id}`}
                              value={index}
                              id='radio-btn'
                              onChange={e =>
                                handleStingerChange(
                                  stri.id,
                                  e.target.value,
                                  'radio',
                                )
                              }>
                              <FormControlLabel
                                value={index}
                                control={<Radio />}
                                checked={index === stri.isSelected}
                                className='text-white mr-0 mt-3'
                                label=''
                              />
                            </RadioGroup>
                          )}
                          <TextField
                            id='message-description'
                            className='w-full text-white radius-5 p-0 min-h-30 h-30'
                            variant='outlined'
                            value={msg}
                            InputProps={{
                              style: {
                                background: '#000000E6',
                              },
                              placeholder: 'Enter Message Name *',
                            }}
                            disabled={
                              stri.message.length !== 1 &&
                              stri.isSelected !== index
                            }
                            onChange={e =>
                              handleStingerChange(
                                stri.id,
                                e.target.value,
                                'message',
                              )
                            }
                          />
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            ))
          : nrStingerScripts &&
            nrStingerScripts?.map(stri => (
              <Box
                m={0}
                className='flex w-full items-start gap-1 pb-5 pl-2'
                sx={{border: '2px dashed var(--blue-variant5)'}}
                key={stri.id}>
                <Checkbox
                  onChange={e =>
                    handleStingerChange(stri.id, e.target.value, 'radio')
                  }
                  checked={stri.isSelected}
                  className='mt-6'
                />

                <TextField
                  id='message-name'
                  className='w-200 text-white radius-5 p-0 min-h-40 h-40'
                  variant='outlined'
                  value={stri.name}
                  InputProps={{
                    style: {
                      background: '#000000E6',
                    },
                    placeholder: 'Message Name *',
                  }}
                  onChange={event =>
                    handleStingerChange(stri.id, event.target.value, 'name')
                  }
                />
                <TextField
                  id='message-description'
                  className='w-full text-white radius-5 p-0 min-h-30 h-30'
                  variant='outlined'
                  value={stri.message}
                  InputProps={{
                    style: {
                      background: '#000000E6',
                    },
                    placeholder: 'Enter Message Name *',
                  }}
                  disabled={!stri.isSelected}
                  onChange={e =>
                    handleStingerChange(stri.id, e.target.value, 'message')
                  }
                />
              </Box>
            ))}
      </Box>
    </Box>
  );
};

export const ContactSelection = ({
  contacts,
  selectedContact,
  setSelectedContact,
}: {
  contacts: ICmpyContacts[];
  selectedContact: number;
  setSelectedContact: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const handleChange = useCallback(
    (e: SelectChangeEvent<number>) => {
      setSelectedContact(Number(e.target.value));
    },
    [setSelectedContact],
  );

  return (
    <Card>
      <Box>
        <Typography variant='h5' className='text-white font-bold mt-2 mb-6 m-0'>
          Select Contact
        </Typography>
      </Box>
      <CardContent>
        <FormControl variant='standard' sx={{width: 300, mx: 'auto'}}>
          <InputLabel id='contact-select'>Contact Person's</InputLabel>
          <Select
            labelId='contact-select'
            id='contact-dropdown'
            value={selectedContact ?? ''}
            onChange={handleChange}>
            {contacts.map(user => {
              return (
                <MenuItem value={user.id} key={user.id}>
                  {user.name}{' '}
                  {user.is_primary_contact ? '(Primary Contact)' : null}
                  {user.is_admin ? '(Admin)' : null}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </CardContent>
    </Card>
  );
};

export const OnboardingMsgRequestReview = ({
  djMessageOptions,
  stingerMessageOptions,
  nrStingerScripts,
  isGT,
  isSZ,
}: {
  djMessageOptions: baseMsgScriptProps[];
  stingerMessageOptions: stringMsgScriptProps[];
  nrStingerScripts?: neptuneStringMsgScriptProps[];
  isGT: boolean;
  isSZ: boolean;
}) => {
  return (
    <Grid item xs={12}>
      <Box>
        <Typography variant='h5' className='text-white font-bold mt-2 mb-9'>
          Review
        </Typography>
      </Box>
      <Grid item xs={12}>
        {!isSZ && (
          <>
            <Box className=''>
              <Box className='mt-5'>
                <Typography
                  variant='h6'
                  gutterBottom
                  className='mb-0 text-white'>
                  DJ Message
                </Typography>
              </Box>
              <Box>
                <ul
                  className='flex flex-wrap justify-center items-center gap-1 h-300 scrollbar overflow-auto'
                  style={{listStyleType: 'none'}}>
                  {djMessageOptions.map(dj => (
                    <li
                      className='flex flex-row w-full justify-center items-center gap-1 '
                      style={{
                        borderBottom: `2px dashed var(--blue-variant7)`,
                      }}
                      key={dj.id}>
                      <Box className='w-p-25'>
                        {dj?.media_track ? (
                          <MusicPreviewBtn
                            id={dj.media_track.id}
                            url={dj.media_track.url}
                            track_artist={dj.media_track?.track_artist ?? ''}
                            track_name={dj.media_track?.track_name ?? ''}
                          />
                        ) : null}
                        <span className='ml-1'>{dj.name}</span>
                      </Box>
                      <Box className='w-p-75 text-white-50'>
                        <pre>{dj.message}</pre>
                      </Box>
                    </li>
                  ))}
                </ul>
              </Box>
            </Box>
          </>
        )}
        <Box className=''>
          <Box className='mt-5'>
            <Typography variant='h6' gutterBottom className='mb-0 text-white'>
              Stinger messages
            </Typography>
          </Box>
          <Box>
            <ul
              className='flex flex-wrap justify-center items-center gap-1 h-300 scrollbar overflow-auto'
              style={{listStyleType: 'none'}}>
              {isGT
                ? stingerMessageOptions.map(st => (
                    <li
                      className='flex flex-row w-full justify-center items-center gap-1 '
                      style={{borderBottom: `2px dashed var(--blue-variant7)`}}
                      key={st.id}>
                      <Box className='w-p-25'> {st.name}</Box>
                      <Box className='w-p-75 text-white-50'>
                        {' '}
                        {st.isSelected !== undefined &&
                          st.message[st.isSelected]}{' '}
                      </Box>
                    </li>
                  ))
                : nrStingerScripts &&
                  nrStingerScripts
                    .filter(st => st.isSelected)
                    .map(st => (
                      <li
                        className='flex flex-row w-full justify-center items-center gap-1 '
                        style={{
                          borderBottom: `2px dashed var(--blue-variant7)`,
                        }}
                        key={st.id}>
                        <Box className='w-p-25'> {st.name}</Box>
                        <Box className='w-p-75 text-white-50'>
                          <pre>{st.message}</pre>
                        </Box>
                      </li>
                    ))}
            </ul>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

type Props = {
  messages: baseMsgScriptProps[];
  setMessages: React.Dispatch<React.SetStateAction<baseMsgScriptProps[]>>;
  setSelectedDjTracks: React.Dispatch<React.SetStateAction<IMediaTrack[]>>;
};
const BaseMessageInput = ({
  messages,
  setMessages,
  setSelectedDjTracks,
}: Props) => {
  const isStaff = useSelector(isInternalSelector);
  const deleteMultiSelectData = (msg: baseMsgScriptProps) => {
    setMessages(prev => prev.filter(v => v.id !== msg.id));
    if (msg.media_track) {
      setSelectedDjTracks(prev => {
        const removedSongs = prev.filter(val => val.id !== msg.media_track?.id);
        return removedSongs;
      });
    }
  };

  const handleEdit = useCallback(
    (msg: baseMsgScriptProps) => {
      setMessages(prev => {
        const messages = [...prev.filter(o => o.name || o.message)];
        const index = messages.findIndex(message => message.id === msg.id);
        if (index !== -1) {
          const splicedMessage = messages.splice(
            index,
            1,
          )[0] as baseMsgScriptProps; // Remove the message from its current position
          messages.unshift(splicedMessage); // Move the message to the first position
        }
        return [...messages];
      });
    },
    [setMessages],
  );

  return (
    <>
      <BaseMessageForm
        key={messages[0]?.id}
        message={messages[0] as baseMsgScriptProps}
        setMessages={setMessages}
      />
      {messages && messages.length > 0 && (
        <Box className='max-h-250 scrollbar overflow-auto'>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {isStaff ? <TableCell>Play</TableCell> : null}
                  <TableCell align='left' width={297}>
                    <Typography className='text-16 opacity-50 text-white'>
                      Message Name
                    </Typography>
                  </TableCell>
                  <TableCell align='left'>
                    <Typography className='text-16 opacity-50 text-white'>
                      Message
                    </Typography>
                  </TableCell>
                  <TableCell width={72}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {messages.map((item, index) => {
                  if (index) {
                    return (
                      <TableRow key={item.id}>
                        {isStaff ? (
                          <TableCell width={80} align='left'>
                            {item.media_track ? (
                              <MusicPreviewBtn
                                id={item.media_track.id}
                                url={item.media_track.url}
                                track_artist={
                                  item.media_track?.track_artist ?? ''
                                }
                                track_name={item.media_track?.track_name ?? ''}
                              />
                            ) : null}
                          </TableCell>
                        ) : null}
                        <TableCell align='left'>
                          <Typography
                            variant='caption'
                            className='text-16 text-white'
                            title={item.name}>
                            {manipulateText(item.name ?? '', 15)}
                          </Typography>
                        </TableCell>
                        <TableCell align='left'>
                          <Typography
                            variant='caption'
                            className='text-16 text-white'
                            title={item.message}>
                            {manipulateText(item.message ?? '', 50)}
                          </Typography>
                        </TableCell>
                        <TableCell align='center'>
                          <Stack direction='row' spacing={1}>
                            <IconEditButton onClick={() => handleEdit(item)} />
                            <IconDeleteButton
                              onClick={() => {
                                deleteMultiSelectData(item);
                              }}
                            />
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  }
                  return null;
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};

const BaseMessageForm = ({
  message,
  setMessages,
}: {
  message: baseMsgScriptProps;
  setMessages: React.Dispatch<React.SetStateAction<baseMsgScriptProps[]>>;
}) => {
  const handleName = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setMessages(prev => {
        return prev.map(val => {
          if (val.id === message.id) {
            return {...val, name: event.target.value};
          }
          return val;
        });
      });
    },
    [message, setMessages],
  );
  const handleMessage = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setMessages(prev => {
        return prev.map(val => {
          if (val.id === message.id) {
            return {...val, message: event.target.value};
          }
          return val;
        });
      });
    },
    [message, setMessages],
  );

  const handleAddMessageDetails = useCallback(() => {
    setMessages(prev => {
      return [
        {
          id: uuidv4(),
          name: '',
          message: '',
          message_type: 'dj',
        },
        ...prev,
      ];
    });
  }, [setMessages]);

  const inValidForm = useMemo(() => {
    if (
      invalidBaseMessageName(message?.name ?? '') ||
      (!message?.media_track && message?.message === '') ||
      message.name.trim().length > 50 ||
      message.message.trim().length <= 10
    ) {
      return true;
    }

    return false;
  }, [message]);

  return (
    <>
      <MessageAlert name={`${message?.name}`} message={message?.message} />
      <Box>
        <Grid container alignItems='center'>
          <Grid item md={6}>
            <TextField
              id='message-name-text'
              placeholder='Message Name*'
              variant='outlined'
              value={message?.name}
              onChange={handleName}
              className='m-h-40 h-40 w-full max-w-400 p-0 my-3'
              InputProps={{
                style: {
                  minHeight: '40px',
                },
              }}
            />
          </Grid>
        </Grid>

        <Stack
          spacing={1}
          direction='row'
          alignItems='end'
          className='textarea_newmsg mb-5'>
          <CustomTextarea
            placeholder='Enter Message here'
            onChange={handleMessage}
            value={message?.message}
          />
          <Stack spacing={2}>
            {message?.media_track ? (
              <MusicPreviewBtn
                id={message.media_track.id}
                url={message.media_track.url}
                track_artist={message.media_track?.track_artist ?? ''}
                track_name={message.media_track?.track_name ?? ''}
              />
            ) : null}
            <MessageAddButton
              isValid={!inValidForm}
              onClick={handleAddMessageDetails}
            />
          </Stack>
        </Stack>
      </Box>
    </>
  );
};
